import { render } from "./forgotpass.vue?vue&type=template&id=2f0033fe&class=bg-gray-bgcolor%20font-nunito"
import script from "./forgotpass.vue?vue&type=script&lang=js"
export * from "./forgotpass.vue?vue&type=script&lang=js"

import "./forgotpass.vue?vue&type=style&index=0&id=2f0033fe&lang=css"
script.render = render

export default script